import styled from 'styled-components'
import { theme } from 'styles/theme'

// TODO: more styles, error handling, disabled state etc
export const Input = styled.input({
  padding: '1em',
  lineHeight: '1em',
  borderRadius: 6,
  fontFamily: theme.typography.fontFamily,
  border: 0,
  outline: 'none',
  backgroundColor: theme.palette.backgroundLight,
  boxShadow: `0 0 0 1px ${theme.palette.borders}`,
  '&:focus': {
    boxShadow: `0 0 0 3px ${theme.palette.accentLight}`,
  },
  '&:disabled': {
    boxShadow: `0 0 0 1px ${theme.palette.accent}`,
  },
  transition: 'all 0.2s ease-in-out',
  marginBottom: 16,
})

export const MinimumInput = styled.input({
  color: '#0e76eb',
  border: 'none',
  transition: 'all 0.2s ease',
  backgroundColor: 'transparent',
  fontSize: 14,
  outline: 'none',
  resize: 'none',
  overflow: 'hidden',
  textAlign: 'left',
  width: 'auto',
})

export const Label = styled.label({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.textSizeSmall,
  marginBottom: 8,
  fontWeight: 'bold',
})
